import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import s from '../../../../../redux/selectors';
import BlankLink from '../../../../common/BlankLink';
import { wrap, withT } from '../../../../../lib/wrappers';

import InlineInput from '../InlineInput';

const SwitchToCfls = ({
  t,
  widgetSource,
}) => (
  <div className="action-details">
    <div className="action-details__form">
      <p>
        {t('I will replace')}
        <InlineInput
          maxLength={3}
          apiKey={'input_takeaction_switch_to_cfl_cfl'}
        />
        {t('older incandescent bulbs with compact florescent bulbs (CFL) or LED bulbs.')}
      </p>
      <p>
        {t('I use the lights about')}
        <InlineInput
          maxLength={3}
          apiKey={'input_takeaction_switch_to_cfl_hours'}
        />
        {t('hours a day on average.')}
      </p>
      {widgetSource !== 'ontario' &&
        <p>
          {t('CFLs contain mercury so be sure to dispose of them safely. Visit the')}
          &nbsp;
          <BlankLink
            href="http://www2.epa.gov/cfl/recycling-and-disposal-after-cfl-burns-out"
            text={t('EPA website')}
          />
          &nbsp;
          {t('to learn more.')}
        </p>
      }
    </div>
    <div className="action-details__facts">
      <p>{t('LED bulbs are high quality, reliable, and long lasting. They can be used to replace a CFL bulb or an incandescent bulb. They also last up to 25 times longer than incandescent light bulbs, and 2 and ½ times longer CFL bulbs.')}</p>
      {widgetSource !== 'ontario' &&
        <p>{t('CFL bulbs use up to 75% less electricity than incandescent light bulbs. Replacing 5 standard incandescent bulbs with CFLs can help you save up to $30 a year, with bulbs that also last up to 10 times longer than incandescent.')}</p>
      }
    </div>
    <div className="action-details__links">
      <p
        dangerouslySetInnerHTML={{
          __html: t('You can save on a variety of energy-efficient products for your home with Save on Energy DEAL DAYS. This includes the purchase of ENERGY STAR® certified LEDs, as well as light fixtures and lighting controls. '),
        }}
      />
      {widgetSource === 'ontario' &&
        <p>
          {t('To learn more about this program and other energy-efficient offers, check out')}
          &nbsp;
          <BlankLink href={`https://${t('greenon.ca/')}`} text="GreenOn.ca" />.
        </p>
      }
      {widgetSource !== 'ontario' && <BlankLink
        href="http://www.coolcalifornia.org/funding-wizard#search/home+electricity//false/none/false/1/12"
        text={t('Find rebates and incentives for this action')}
      />}
    </div>
    <div className="action-details__assumptions">
      <div className="action-details__assumptions__header">{t('Assumptions')}</div>
      <ul>
        <li>
          {t('Wattage of incandescent bulbs:')}
          <InlineInput
            maxLength={3}
            apiKey="input_takeaction_switch_to_cfl_incanwatt"
          />
        </li>
        <li>
          {t('Equivalent wattage of CFL bulbs:')}
          <InlineInput
            maxLength={3}
            apiKey="input_takeaction_switch_to_cfl_cflwatt"
          />
        </li>
        <li>
          {t('Cost per new CFL:')}
          <InlineInput
            currency
            maxLength={5}
            apiKey="input_takeaction_switch_to_cfl_cflcost"
          />
        </li>
        <li>
          {t('Cost to run incandescent bulb:')}
          <InlineInput
            currency
            maxLength={3}
            apiKey="input_takeaction_switch_to_cfl_incancost"
          />
          {t('per day')}
        </li>
        <li>
          {t('Lifetime of incandescents:')}
          <InlineInput
            apiKey="input_takeaction_switch_to_cfl_incanlife"
          />
          {t('hours')}
        </li>
        <li>
          {t('Lifetime of CFLs:')}
          <InlineInput
            apiKey="input_takeaction_switch_to_cfl_cfllife"
          />
          {t('hours')}
        </li>
        <li>
          {t('cost of electricity')}
          <InlineInput
            apiKey="input_takeaction_assumption_kwhprice"
            maxLength={3}
          />
          {t('cents per kWh')}
        </li>
      </ul>
    </div>
  </div>
);

SwitchToCfls.propTypes = {
  // wrapped
  t: PropTypes.func.isRequired,
  // connected props
  widgetSource: PropTypes.string.isRequired,
};

const mapStateToProps = (state, ownProps) => [
  'widgetSource',
].reduce((props, selector) => ({
  ...props,
  [selector]: s[selector](state, ownProps),
}), {});

const mapDispatchToProps = () => ({});

export default wrap(
  withT('switchToCfl'),
  connect(mapStateToProps, mapDispatchToProps)(SwitchToCfls),
);
